import { showLog } from "../utils/log";

const init = {
  userId: "",
  distanceMatrixService: "",
  lookData: [],
};

const authReducer = (state = init, action) => {
  showLog("Store Masuk authReducer");
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        userId: action.payload,
      };
    case "DISTANCE_MATRIX":
      return {
        ...state,
        distanceMatrixService: action.payload,
      };
    case "SET_LOOK_DATA":
      return {
        ...state,
        lookData: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
